/* retro-player-select.js — "Choose Your Player" quiz overlay.
   Loaded with defer from sections/retro-player-select.liquid, so it never
   touches LCP. All copy, products, prices and trigger rules come from the
   section config emitted by Liquid; nothing here is hardcoded. */
(function () {
  var tag = document.currentScript;
  var sectionId = tag && tag.getAttribute('data-ps-section');
  if (!sectionId) return;

  var overlay = document.getElementById('ps-' + sectionId);
  var cfgEl = document.getElementById('ps-config-' + sectionId);
  if (!overlay || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var P = cfg.products, C = cfg.copy;
  var stage = overlay.querySelector('.ps-stage');
  var dots = overlay.querySelectorAll('.ps-dots i');
  var lastFocus = null;
  var SEEN = 'bf_ps_seen', STAMP = 'bf_ps_dismissed_at';

  /* ---- analytics: no PII ever leaves here ---- */
  function push(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    window.dataLayer.push(payload);
  }

  /* ---- inline stroke icons, replacing the concept's emoji ---- */
  var ICONS = {
    lift: '<svg viewBox="0 0 24 24"><path d="M4 9v6M20 9v6M7 7v10M17 7v10M7 12h10"/></svg>',
    drop: '<svg viewBox="0 0 24 24"><path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3Z"/></svg>',
    bolt: '<svg viewBox="0 0 24 24"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/></svg>',
    moon: '<svg viewBox="0 0 24 24"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z"/></svg>'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function setDots(n) {
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i < n);
  }

  /* ---- step 1 ---- */
  function q1() {
    setDots(1);
    var cards = C.cards.map(function (c, i) {
      return '<button type="button" class="ps-player" data-path="' + esc(c.path) + '" data-choice="' + (i + 1) + '">' +
        '<span class="ico" aria-hidden="true">' + (ICONS[c.icon] || '') + '</span>' +
        '<b>' + esc(c.label) + '</b><small>' + esc(c.sub) + '</small></button>';
    }).join('');
    stage.innerHTML =
      '<h2 class="ps-q" id="ps-title-' + sectionId + '">' + esc(C.q1_head) + ' <span class="mk">' + esc(C.q1_mark) + '</span></h2>' +
      '<p class="ps-sub">' + esc(C.q1_sub) + '</p>' +
      '<div class="ps-players">' + cards + '</div>' +
      '<button type="button" class="ps-skip" data-skip>' + esc(C.skip) + '</button>';
    bind();
  }

  /* ---- step 2 ---- */
  function q2() {
    setDots(2);
    var rows = C.levels.map(function (l) {
      var bars = '';
      for (var i = 1; i <= 3; i++) bars += '<i class="' + (i <= l.bars ? 'f' : '') + '"></i>';
      return '<button type="button" class="ps-lvl" data-result="' + esc(l.key) + '">' +
        '<span class="bars" aria-hidden="true">' + bars + '</span>' +
        '<span><b>' + esc(l.label) + '</b><small>' + esc(l.sub) + '</small></span></button>';
    }).join('');
    stage.innerHTML =
      '<h2 class="ps-q">' + esc(C.q2_head) + ' <span class="mk">' + esc(C.q2_mark) + '</span></h2>' +
      '<p class="ps-sub">' + esc(C.q2_sub) + '</p>' +
      '<div class="ps-levels">' + rows + '</div>';
    bind();
    focusFirst();
  }

  /* ---- result ---- */
  function result(key) {
    setDots(3);
    var m = P[key];
    if (!m) return;
    push('bf_quiz_result', { product: m.name });

    var specs = (m.specs || []).filter(Boolean).map(function (s) {
      return '<span>' + esc(String(s).trim()) + '</span>';
    }).join('');

    // Sold out: keep the CTA working through to the PDP, where notify-me lives.
    var priceBlock = m.available
      ? '<span class="ps-price">' + esc(m.price) + '</span>'
      : '<span class="ps-price">' + esc(m.price) + '</span><span class="ps-soldout">' + esc(C.soldout) + '</span>';

    var gate = '';
    if (cfg.klaviyoListId) {
      gate = '<p class="ps-herd">' + esc(C.herd) + ' <button type="button" data-gate>' + esc(C.herd_cta) + '</button></p>' +
        '<div class="ps-gate"><input type="email" data-email placeholder="you@example.com" aria-label="Email">' +
        '<p class="err" data-err role="alert"></p>' +
        '<button type="button" class="bf-btn bf-btn--pink" data-send><span>' + esc(C.gate_btn) + '</span></button></div>';
    }

    stage.innerHTML =
      '<p class="ps-ready">' + esc(C.ready) + '</p>' +
      '<h2 class="ps-q">' + esc(C.res_head) + ' <span class="mk">' + esc(C.res_mark) + '</span></h2>' +
      '<div class="ps-match"><span class="tag">' + esc(m.tag) + '</span><h3>' + esc(m.name) + '</h3>' +
      '<p>' + esc(m.blurb) + '</p><div class="ps-specs">' + specs + '</div>' +
      '<div class="ps-rowp">' + priceBlock + '</div></div>' +
      '<div class="ps-ctas">' +
      '<a class="bf-btn bf-btn--pink" href="' + esc(m.url) + '"><span>' + esc(C.cta) + '</span></a>' +
      '<button type="button" class="bf-btn bf-btn--cyan" data-restart><span>' + esc(C.again) + '</span></button>' +
      '</div>' + gate;
    bind();
    focusFirst();
  }

  function bind() {
    stage.querySelectorAll('[data-path]').forEach(function (b) {
      b.addEventListener('click', function () {
        var path = b.getAttribute('data-path');
        push('bf_quiz_answer', { step: 1, choice: b.getAttribute('data-choice') });
        if (path === 'power') q2(); else result(path);
      });
    });
    stage.querySelectorAll('[data-result]').forEach(function (b) {
      b.addEventListener('click', function () {
        push('bf_quiz_answer', { step: 2, choice: b.getAttribute('data-result') });
        result(b.getAttribute('data-result'));
      });
    });
    var skip = stage.querySelector('[data-skip]');
    if (skip) skip.addEventListener('click', function () { close('skip'); });
    var again = stage.querySelector('[data-restart]');
    if (again) again.addEventListener('click', q1);

    var gateBtn = stage.querySelector('[data-gate]');
    if (gateBtn) gateBtn.addEventListener('click', function () {
      var g = stage.querySelector('.ps-gate');
      g.classList.add('is-open');
      var i = g.querySelector('[data-email]'); if (i) i.focus();
    });
    var send = stage.querySelector('[data-send]');
    if (send) send.addEventListener('click', function () {
      var input = stage.querySelector('[data-email]');
      var err = stage.querySelector('[data-err]');
      var v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.textContent = C.gate_err; return; }
      err.textContent = '';
      send.disabled = true;
      subscribe(v).then(function () {
        /* DO NOT branch this message on data.is_subscribed. Measured against
           list UG8NCp on 2026-08-31: the FIRST submit for an address returns
           is_subscribed:false and the second returns true, with no confirmation
           link ever clicked. The flag reports membership BEFORE the call, not
           the outcome of it, so on this single opt-in list every genuine
           first-time subscriber returns false. Treating that as "pending" told
           exactly the people who had just succeeded to go and look for a
           confirmation email that is never sent. */
        send.querySelector('span').textContent = C.gate_ok;
        push('bf_quiz_email_submitted', {});   // no PII in the event
      }).catch(function () {
        send.disabled = false;
        err.textContent = C.gate_err;
      });
    });
  }

  /* Klaviyo client subscribe. Only reachable when a List ID is configured,
     so an unset ID hides the offer rather than failing silently. */
  function subscribe(email) {
    var body = new URLSearchParams();
    body.append('g', cfg.klaviyoListId);
    body.append('email', email);
    body.append('$fields', 'email');
    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function (r) {
      if (!r.ok) throw new Error('subscribe failed');
      /* Klaviyo answers 200 even when it REJECTS the address — the verdict is
         in the body, not the status line. Trusting r.ok alone meant the button
         could say "Code sent — welcome to the Herd" to someone Klaviyo had just
         refused, and no email would ever arrive. Same trap as a discount-code
         URL returning 200 for a code that does not exist: a status is not an
         outcome. A non-JSON body falls back to the status, which is the only
         honest reading when there is nothing else to go on. */
      return r.json().then(function (d) {
        if (d && d.success === false) {
          throw new Error((d.errors && d.errors[0]) || 'subscribe rejected');
        }
        return d;
      }, function () { return null; });
    });
  }

  function focusFirst() {
    var f = stage.querySelector('button, a[href], input');
    if (f) f.focus();
  }

  function open() {
    if (overlay.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    // next frame so the opacity transition actually runs
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    q1();
    focusFirst();
    try { localStorage.setItem(SEEN, '1'); } catch (e) {}
    push('bf_quiz_open', {});
  }

  function close(reason) {
    overlay.classList.remove('is-open');

    /* The quiz auto-opens, so lastFocus is usually document.body, and
       body.focus() is a no-op — focus stayed on whatever was focused inside
       the dialog, which then got the hidden attribute. A keyboard user was
       left focused on an element with no box, and the next Tab jumped from
       nowhere. Blur out of the overlay first, then restore only to a target
       that can actually take focus. */
    var active = document.activeElement;
    if (active && overlay.contains(active) && active.blur) active.blur();

    setTimeout(function () { overlay.hidden = true; }, 300);
    try { localStorage.setItem(STAMP, String(Date.now())); } catch (e) {}

    if (lastFocus && lastFocus.focus && lastFocus !== document.body &&
        (lastFocus.isConnected !== false) && document.contains(lastFocus)) {
      lastFocus.focus();
    }
    push('bf_quiz_dismissed', { reason: reason || 'close' });
  }

  overlay.querySelector('.ps-close').addEventListener('click', function () { close('close'); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close('backdrop'); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close('esc');
  });
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = overlay.querySelectorAll('button:not([disabled]), input, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---- trigger rules ---- */
  function suppressed() {
    try {
      var t = parseInt(localStorage.getItem(STAMP) || '0', 10);
      if (!t) return false;
      return (Date.now() - t) < cfg.suppressDays * 86400000;
    } catch (e) { return false; }
  }
  function seen() { try { return localStorage.getItem(SEEN) === '1'; } catch (e) { return false; } }

  /* Stand down if the retiring quiz app's popup is on the page - two modals
     fighting is worse than no modal. Logged so the collision is visible. */
  function rivalModal() {
    var sel = '[class*="presidio"],[id*="presidio"],[class*="quiz-container"],[class*="quiz-content"],' +
              '[id*="product-recommendation-quiz"],[class*="product-recommendation-quiz"]';
    return document.querySelector(sel);
  }

  function maybeOpen() {
    if (seen() || suppressed()) return;
    var rival = rivalModal();
    if (rival) {
      console.warn('[bf player-select] standing down: another quiz modal is present in the DOM ->',
        rival.className || rival.id);
      push('bf_quiz_suppressed_collision', {});
      return;
    }
    open();
  }

  /* Test bypass: ?bf_quiz=1 forces the quiz open regardless of the seen /
     suppressed stamps, and clears them so repeat previews behave like a first
     visit. Review needs to see this on demand; real visitors never hit it
     because it requires the explicit query string. */
  var forced = /[?&]bf_quiz=1\b/.test(location.search);
  if (forced) {
    try { localStorage.removeItem(SEEN); localStorage.removeItem(STAMP); } catch (e) {}
  }

  var fired = false;
  function once() { if (fired) return; fired = true; maybeOpen(); }

  if (forced) {
    // still respects the rival-modal check - two modals fighting is never right
    setTimeout(once, 200);
  } else if (!seen() && !suppressed()) {
    setTimeout(once, cfg.delayMs);
    window.addEventListener('scroll', function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= cfg.scrollPct) {
        window.removeEventListener('scroll', onScroll);
        once();
      }
    }, { passive: true });
  }
})();
